import { OLAF } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
export const FeedbackContainer = styled(UITile).withConfig({
  displayName: "feedbackstyles__FeedbackContainer",
  componentId: "sc-1o2qiyd-0"
})(["position:fixed !important;bottom:0;right:0;z-index:100;background-color:", ";box-shadow:0 0 5px rgba(0,0,0,0.25);border-radius:6px;display:inline-block;margin:10px;overflow:hidden;", ";"], OLAF, props => props.maxWidth && `max-width: ${props.maxWidth};`);
export const FeedbackTileSection = styled(UITileSection).withConfig({
  displayName: "feedbackstyles__FeedbackTileSection",
  componentId: "sc-1o2qiyd-1"
})(["padding:10px !important;"]);
export const FeedbackHeader = styled.div.withConfig({
  displayName: "feedbackstyles__FeedbackHeader",
  componentId: "sc-1o2qiyd-2"
})(["background-color:rgb(62,89,116);color:", ";padding:15px 40px;font-size:0.95rem;font-weight:600;line-height:1.7rem;text-align:center !important;"], OLAF);
export const Rating = styled.span.withConfig({
  displayName: "feedbackstyles__Rating",
  componentId: "sc-1o2qiyd-3"
})(["border-left:18px solid transparent;display:inline-block;line-height:0;margin-bottom:16px !important;"]);
export const RatingIcon = styled.span.withConfig({
  displayName: "feedbackstyles__RatingIcon",
  componentId: "sc-1o2qiyd-4"
})(["border-color:transparent;cursor:pointer;display:inline-block;border-radius:50%;border-style:solid;border-width:6px;padding:6px;transition:border-color 0.2s linear 0s;&:hover{", "}"], props => `border-color: ${props.color};`);
export const SuccessIllustration = styled(UIIllustration).withConfig({
  displayName: "feedbackstyles__SuccessIllustration",
  componentId: "sc-1o2qiyd-5"
})(["height:150px;margin-right:15px;vertical-align:middle;display:inline-block;"]);
export const ThankYouTextContainer = styled.div.withConfig({
  displayName: "feedbackstyles__ThankYouTextContainer",
  componentId: "sc-1o2qiyd-6"
})(["max-width:50vw;vertical-align:middle;text-align:center !important;display:inline-block !important;"]);
export const ThankYouTitle = styled.div.withConfig({
  displayName: "feedbackstyles__ThankYouTitle",
  componentId: "sc-1o2qiyd-7"
})(["font-size:0.95rem;font-weight:600;line-height:1.7rem;"]);
export const ThankYouMessage = styled.div.withConfig({
  displayName: "feedbackstyles__ThankYouMessage",
  componentId: "sc-1o2qiyd-8"
})(["font-size:14px !important;"]);